import CityPageTemplate from "../city-template/CityPageTemplate";
import { jacksonConfig } from "./data";

export default function JacksonMIPage() {
  return <CityPageTemplate config={jacksonConfig} />;
}